import { Icon, IconProps } from '~/components/Icon/Icon';

export const DottedIndent = (props: IconProps) => (
  <Icon
    width="5"
    height="5"
    viewBox="0 0 5 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <rect width="1" height="1" fill="currentColor" />
    <rect y="2" width="1" height="1" fill="currentColor" />
    <rect x="2" y="4" width="1" height="1" fill="currentColor" />
    <rect y="4" width="1" height="1" fill="currentColor" />
    <rect x="4" y="4" width="1" height="1" fill="currentColor" />
  </Icon>
);
